import React from 'react';
import StoreLogo from '@prisjakt/ui-store-logo';
import { Store } from 'src/types';
import { Rating } from '@prisjakt/ui-rating/src/types';
import { SHOP_LOGO_WIDTH } from '../../../../../../store/constants';
import { VARIANTS, StoreInfo, StoreInfoTitle } from './styles';
import { StoreRatingAverage } from '../store-rating-average';

interface IStoreInfoColumn {
  store: Store;
  rating?: Rating;
}

const StoreInfoColumn: React.FC<IStoreInfoColumn> = props => {
  const { store, rating } = props;
  const highResolutionLogo = store.logo
    ? { url: store.logo, width: SHOP_LOGO_WIDTH }
    : null;
  return (
    <StoreInfo>
      <StoreInfoTitle>{store.name}</StoreInfoTitle>
      <StoreLogo
        name={store.name}
        storeId={store.id}
        featured={Boolean(store.featured)}
        hasImage={Boolean(store.hasLogo)}
        variant={VARIANTS.PRICE_LIST}
        logoUrl={highResolutionLogo?.url}
        width={highResolutionLogo?.width}
        showHighResolutionLogo={Boolean(highResolutionLogo)}
      />
      <StoreRatingAverage store={store} rating={rating} showReviewCount />
    </StoreInfo>
  );
};

export { StoreInfoColumn };
